import './App.css';

function App() {
  return (
    <div className="bg-gray-950 min-h-screen flex items-center justify-center px-6">
      <main className="text-center max-w-md">
        <h1 className="text-gray-100 text-2xl sm:text-3xl font-semibold">
          Web stranica je privremeno nedostupna
        </h1>
        <p className="text-gray-400 mt-4 text-base leading-relaxed">
          Stranica je izvan funkcije zbog uskla&#273;ivanja s izmjenama propisa.
          Hvala na razumijevanju.
        </p>
      </main>
    </div>
  );
}

export default App;
